import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { ScrollTable } from './ScrollTable';
import { moduleComparison, moduleIncludes } from '../data/content';
export function ModuleSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="modulo-title" data-id="element-170" data-mp="16bxs7044ao77">
      <div className="mx-auto max-w-5xl" data-id="element-171" data-mp="wk0hrvkxo09j">
        <SectionHeading eyebrow="🏋️ Módulo Premium" title="¿Qué agrega Torso Definido: Abdomen, Pecho y Hombros?" data-id="element-172" data-mp="wj8jgczybofk" />

        <div className="mt-10" data-id="element-173" data-mp="11cl4kd5f9d3k">
          <ScrollTable data-id="element-174" data-mp="nk50ra4p5b1l">
            <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-175" data-mp="nkn8b2wt7bot">
              <caption className="sr-only" data-id="element-176" data-mp="rk5mzgy1eqj7">
                Comparación entre entrenar sin el módulo Torso Definido y con él
              </caption>
              <thead data-id="element-177" data-mp="dn8yhm5e5l5h">
                <tr className="bg-ink" data-id="element-178" data-mp="ijzhah8kyuul">
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-neutral-300" data-id="element-179" data-mp="iixtrdadofvz">
                    Situación en tu entrenamiento
                  </th>
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-ember" data-id="element-180" data-mp="399ht37cnzo30">
                    ❌ Sin Torso Definido
                  </th>
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-gold" data-id="element-181" data-mp="2glvqo2f6aphq">
                    ✅ Con Torso Definido
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-182" data-mp="2ljx8yl4ryks5">
                {moduleComparison.map(row => <tr key={row.situation} className="border-t border-line" data-id="element-183" data-mp="1xul0jnh9ugqw">
                    <th scope="row" className="px-5 py-4 text-sm font-semibold text-white" data-id="element-184" data-mp="1xsi2qh9vnjbm">
                      {row.situation}
                    </th>
                    <td className="px-5 py-4 text-sm text-neutral-500" data-id="element-185" data-mp="1rgaoc9t88iz">
                      {row.without}
                    </td>
                    <td className="px-5 py-4 text-sm font-medium text-neutral-200" data-id="element-186" data-mp="6hwse8knygb5">
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </ScrollTable>
        </div>

        <div id="modulo-title" className="mt-10 rounded-3xl border border-gold/25 bg-ink p-6 sm:p-8" data-id="element-187" data-mp="3a181tgw6zhcp">
          <h3 className="text-lg font-extrabold tracking-tight text-gold" data-id="element-188" data-mp="3jwtce3fbtpy2">
            ✅ El módulo Torso Definido incluye:
          </h3>
          <ul className="mt-5 grid gap-3 md:grid-cols-2" data-id="element-189" data-mp="3nzzfx3b2130u">
            {moduleIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-190" data-mp="z6kichgcxtv1">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-191" data-mp="137e4b5a8oyla" />
                <span className="text-sm text-neutral-300" data-id="element-192" data-mp="2nsat2rz2eu2k">{item}</span>
              </li>)}
          </ul>
        </div>

        <p className="mt-6 flex items-start gap-2 text-xs text-neutral-500" data-id="element-193" data-mp="2exmnf0pkvad8">
          <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-194" data-mp="29z31v1ewc0le" />
          Sin el módulo seguís teniendo los 6 tomos y los 5 bonos completos.
        </p>
      </div>
    </section>;
}